import { InjectionToken } from '@angular/core';
import { FirebaseApp } from 'firebase/app';

/**
 * The initialised `FirebaseApp`, held so `AnalyticsService` can construct an
 * Analytics instance the moment someone accepts, instead of making them reload.
 *
 * Deliberately a token local to this entry point rather than a reach into the
 * firebase entry point's `FIREBASE_APP`: cross-entry-point imports are what
 * currently break this library's ng-packagr build.
 *
 * Registering it costs nothing — it is a value that already exists. Analytics is
 * still only initialised behind an explicit `isEnabled` consent.
 */
export const ANALYTICS_FIREBASE_APP = new InjectionToken<FirebaseApp>(
  'ANALYTICS_FIREBASE_APP',
);
